import { render, staticRenderFns } from "./FaqFilter.vue?vue&type=template&id=3073cc91&scoped=true"
import script from "./FaqFilter.vue?vue&type=script&lang=js"
export * from "./FaqFilter.vue?vue&type=script&lang=js"
import style0 from "./FaqFilter.vue?vue&type=style&index=0&id=3073cc91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3073cc91",
  null
  
)

export default component.exports